import React, { useState } from 'react'
import styles from './InterestsModal.module.css'

const InterestsModal = ({ isOpen, onClose, onSave, currentInterests = [] }) => {
  const interests = [
    { id: 'MUSIC', label: '음악', icon: 'fas fa-music' },
    { id: 'NATURE_ANIMAL', label: '자연 / 동물', icon: 'fas fa-palette' },
    { id: 'GAME', label: '게임', icon: 'fas fa-gamepad' },
    { id: 'FITNESS', label: '운동 / 피트니스', icon: 'fas fa-dumbbell' },
    { id: 'BOOK_WRITING', label: '책 / 글쓰기', icon: 'fas fa-book' },
    { id: 'MOVIE_DRAMA', label: '영화 / 드라마', icon: 'fas fa-film' },
    { id: 'TRAVEL', label: '여행', icon: 'fas fa-plane' },
    { id: 'FASHION_STYLE', label: '패션 / 스타일', icon: 'fas fa-tshirt' },
    { id: 'FOOD_COOKING', label: '음식 / 요리', icon: 'fas fa-utensils' },
    { id: 'ART_DESIGN', label: '미술 / 디자인', icon: 'fas fa-pen-nib' }
  ]

  const [selectedInterests, setSelectedInterests] = useState(
    currentInterests.length > 0 ? currentInterests : []
  )
  const [showValidation, setShowValidation] = useState(false)

  if (!isOpen) return null

  const toggleInterest = (interestId) => {
    setSelectedInterests(prev => {
      let nextSelection
      if (prev.includes(interestId)) {
        nextSelection = prev.filter(id => id !== interestId)
      } else {
        nextSelection = [...prev, interestId]
      }

      if (showValidation && nextSelection.length > 0) {
        setShowValidation(false)
      }

      return nextSelection
    })
  }

  const handleSave = () => {
    if (selectedInterests.length === 0) {
      setShowValidation(true)
      return
    }

    onSave(selectedInterests)
    onClose()
  }

  const handleCancel = () => {
    setSelectedInterests(currentInterests.length > 0 ? currentInterests : [])
    setShowValidation(false)
    onClose()
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>관심사 (1개 이상 선택)</h2>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.interestGrid}>
            {interests.map(({ id, label }) => (
              <button
                key={id}
                type="button"
                className={`${styles.interestBtn} ${
                  selectedInterests.includes(id) ? styles.selected : ''
                }`}
                onClick={() => toggleInterest(id)}
                aria-pressed={selectedInterests.includes(id)}
              >
                {label}
              </button>
            ))}
          </div>

          {showValidation && selectedInterests.length === 0 && (
            <p className={styles.validationMessage}>
              관심사를 최소 1개 이상 선택해주세요.
            </p>
          )}
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            취소
          </button>
          <button
            className={styles.confirmBtn}
            onClick={handleSave}
            disabled={selectedInterests.length === 0}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export default InterestsModal
